import { FC } from 'react';

import {
  Area,
  AreaChart,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

import { EType, TNormalizedItem } from '../../types';
import { getFormattedDate } from '../../utils';
import { CustomActiveDotLine } from './CustomActiveDotLine';
import { CustomAxisTick } from './CustomAxisTick';
import { CustomTooltip } from './CustomTooltip';

export interface IChartProps {
  type: EType;
  data: Array<TNormalizedItem>;
}
export const Chart: FC<IChartProps> = ({ data, type }) => {
  const isOnePoint = data.length === 1;

  const view = isOnePoint ? [...data, ...data, ...data] : data;
  const key: keyof TNormalizedItem =
    type === EType.UNIQUE
      ? 'clients'
      : type === EType.NEW
      ? 'newClients'
      : 'total';

  return (
    <ResponsiveContainer width="100%" height="100%">
      <AreaChart data={view}>
        <defs>
          <linearGradient id="gradient" x1="0" y1="0" x2="0" y2="1">
            <stop
              offset="5%"
              stopColor="var(--icon-link-info)"
              stopOpacity={0.5}
            />
            <stop
              offset="100%"
              stopColor="var(--icon-link-info)"
              stopOpacity={0}
            />
          </linearGradient>
        </defs>
        <ReferenceLine
          x={isOnePoint ? 0 : view[0]?.date}
          stroke="var(--text-secondary)"
          strokeDasharray="6 6"
          isFront
        />
        <ReferenceLine
          x={isOnePoint ? view.length - 1 : view[view.length - 1]?.date}
          stroke="var(--text-secondary)"
          strokeDasharray="6 6"
          isFront
        />
        <XAxis
          dataKey="date"
          axisLine={false}
          tickLine={false}
          interval={view.length - 2}
          allowDuplicatedCategory
          tick={<CustomAxisTick isXAxis />}
          tickFormatter={getFormattedDate()}
        />
        <YAxis
          type="number"
          dataKey={key}
          width={64}
          tickLine={false}
          axisLine={false}
          allowDecimals={false}
          tick={<CustomAxisTick />}
        />

        <Tooltip
          cursor={<CustomActiveDotLine />}
          isAnimationActive={isOnePoint}
          content={({ payload }) => {
            return <CustomTooltip data={payload?.[0]?.payload} />;
          }}
        />
        <Area
          type="monotone"
          dataKey={key}
          stroke="var(--icon-link-info)"
          fillOpacity={1}
          fill="url(#gradient)"
          activeDot={{ stroke: 'var(--bg-blue-10)', strokeWidth: 4, r: 2 }}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};
